export default __webpack_public_path__ + "static/superior_jack-80dc4921f5ee01ba794812d53b688328.png";